/**
  Use these spacings for margins/paddings and other whitespace throughout your app.
 */
export const spacingLight = {
  xxxs: 2,
  xxs: 4,
  xs: 8,
  sm: 12,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48,
  xxxl: 64,
} as const
